import { useContext } from 'react'

import type { CompareSelectionContextValue } from './CompareSelectionContext'
import { CompareSelectionContext } from './CompareSelectionContext'

export const useCompareSelection = (): CompareSelectionContextValue => {
  const ctx = useContext(CompareSelectionContext)
  if (!ctx)
    throw new Error(
      'useCompareSelection must be used within CompareSelectionProvider'
    )
  return ctx
}
